import { createFileRoute } from '@tanstack/react-router';
import { DeepLink } from '@/features/system/DeepLink';

export const Route = createFileRoute('/_app/open-app')({
  component: DeepLink,
  validateSearch: (s: Record<string, unknown>) => ({
    target: typeof s.target === 'string' ? s.target : undefined,
    openTask: typeof s.openTask === 'string' ? s.openTask : undefined,
    tab: typeof s.tab === 'string' ? s.tab : undefined,
  }),
});
